import { Alert } from 'components/Alert'
import { adCodeStrings } from 'constants/strings'
import { useLineChannelAccounts } from 'hooks'
import { ELineChannelStatus, ELineWebhookStatus } from 'types'

/**
 * 払い出せるLINEアカウントが1つも無いときの警告。
 *
 * `/a/{code}` は組織の払い出し可能なアカウントから選ぶので、全滅していると発行URLは
 * 「受付停止中」に着く。QRを刷ってから気づくと取り返しがつかないため、
 * URLを見せる画面（詳細）と作る画面で先に伝える。
 *
 * 判定はbackendの払い出し条件（`allocatableChannelWhere`）に揃える。稼働中
 * （ACTIVE/FULL）だけでは足りず、webhook検証済み・basicId非空も要る。未検証や
 * basicIdが空のアカウントを払い出すとLINE STOREへ飛ぶ不正なURLになるため、
 * backend側が候補から外している。
 */
export function NoActiveChannelAlert() {
  const { accounts, loading } = useLineChannelAccounts()

  const hasAllocatableChannel = accounts.some(
    (account) =>
      (account.status === ELineChannelStatus.ACTIVE ||
        account.status === ELineChannelStatus.FULL) &&
      account.webhookStatus === ELineWebhookStatus.VERIFIED &&
      account.basicId !== '',
  )

  if (loading || hasAllocatableChannel) return null

  return (
    <div className="mt-4">
      <Alert>{adCodeStrings.noActiveChannel}</Alert>
    </div>
  )
}
